import styled, { css } from 'styled-components';
import Button from 'components/ui/Button';

import { colours } from 'themes/default';

export const StyledHeader = styled.header`
  margin-bottom: 45px;

  h1 {
    margin-bottom: 5px;
  }
`;

export const StyledGenericMessage = styled.div`
  display: flex;
  margin-top: 8px;
  color: ${colours.Messaging.ErrorRed};
  padding: 12px;
`;

export const StyledMessage = styled.span`
  display: flex;
  margin-bottom: 24px;
`;

export const SubmitButton = styled(Button)`
  height: 40px;
  margin: 0 0 0 8px;
`;

export const HotelDetailsContainer = styled.div`
  padding: 20px;
  background-color: white;
  box-shadow: rgb(238 238 238) 0px 0px 30px;
`;

export const StyledPrice = styled.div`
  background: aliceblue;
  padding: 8px 16px;
  text-align: right;
`;

export const VerticalLine = styled.div`
  border-right: solid 1px rgb(188, 188, 188);
  padding: 0 16px;
`;

export const StyledHr = styled.hr`
  width: 100%;
  color: rgb(188, 188, 188);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ActionContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 0 10px 0 10px;
  overflow: hidden;
  height: 0;

  ${(props) =>
    props.isExpanded &&
    css`
      height: ${(p) => (p.height ? p.height : 'auto')};
    `}

  ${(props) =>
    props.shouldTransition &&
    css`
      transition: all 0.4s ease-in-out;
    `}
`;
